import RestAPI from "@aws-amplify/api-rest";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingDialog from "../Utils/LoadingDialog";
import { dateFormat, utcToDate } from "../../utils/date";
import SystemEventsTable from "./SystemEventsTable";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";


const SystemEvents = ({ dataFarm }) => {
    const { t, i18n } = useTranslation();
    const [rangeDates, setRangeDates] = useState(null);
    const [events, setEvents] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);

    useEffect(() => {
        events && setEvents(events.map(el => ({
            ...el,
            descripcionTrans: t(`systemEvents.description.${el.descripcion}`),
        })));

    }, [i18n.language]);

    const getDatos = async (from, to) => {
        if(!rangeDates){
            setRangeDates([from,to]);
        }
        !dataLoading && setDataLoading(true);
        const queryStringParameters = {
            startTz: from.toISOString().split("T")[0],
            endTz: to.toISOString().split("T")[0]
        };
        let data = await RestAPI.get(
            "apiAdminDropControl",
            `/farms/${dataFarm.campo_id}/bitacora`,
            { queryStringParameters }).catch(e => {
            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            return [];
        });

        data = data.map(el => ({
            ...el,
            descripcionTrans: t(`systemEvents.description.${el.descripcion}`),
            fecha: dateFormat(utcToDate(el.fecha_utc, dataFarm.huso_horario, true), t, i18n.language, dataFarm.huso_horario, false, true),
            itemColumn: resolveItemColumn(el, i18n)
        }));
        setEvents(data);
        setDataLoading(false);
    };

    useEffect(() => {
        const now = new Date();
        const startPeriod = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29);
        getDatos(startPeriod, now);
    }, [dataFarm.huso_horario]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const desde = rangeDates && Array.isArray(rangeDates) && rangeDates[0] || null;
        let hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[1] || null;
        if(!hasta){
            hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[0] || null;
        }
        if(!desde || !hasta){
            toast.error(t("daterangepicker.error1Date"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
        }else{
            getDatos(desde, hasta);
        }
    };

    return (
        <div className='row-container'>
            <div className='col-xl-12 col-lg-12 col-sm-12'>
                <div id="cardBitacora" className="card">
                    {dataLoading && <LoadingDialog appendTo="self" />}
                    <div className="card-body">
                        <div className='row'>
                            <div className='col col-12 text-center'>
                                <h5 className="card-title"><span>{t("farms.etiqueta.systemEvents")}</span></h5>
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="row linea-formulario">
                                    <div className="col-12 col-md-6 text-md-right mtem-05">
                                        <label className="boldie">{t("forms.rangoFechas")}</label>
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                        <CalendarPrime
                                            id="daterangepicker"
                                            t={t}
                                            readOnlyInput
                                            maxDate={new Date()}
                                            maxDaysRange={31}
                                            setValue={setRangeDates}
                                            value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                                            locale={i18n.language}
                                            selectionMode="range"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <ButtonPrime onClick={handleSubmit} label={t("forms.btnSendRequest")} />
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        {!events?.length ?
                            <span className='no-data'>{t("forms.noData")}</span>
                            : <SystemEventsTable eventsData={events} timezone={dataFarm.huso_horario} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

const resolveItemColumn = (event, i18n) => {
    let pk;
    if (event.id_key === "admin.dropcontrol.nodo") return event.nombre_nodo || "";
    else if (event.id_key === "admin.dropcontrol.sector") return event.nombre_sector || "";
    else if (event.id_key === "admin.dropcontrol.block") pk = "bloque_id";
    else if (event.id_key === "admin.dropcontrol.equipo") pk = "equipo_id";
    else if (event.id_key === "admin.dropcontrol.pozo") pk = "dgas_mee_id";
    else if (event.id_key === "admin.dropcontrol.distribuidor") pk = "distribuidor_id";
    else if (event.id_key === "admin.dropcontrol.external") pk = "tipo";
    else if (event.id_key === "admin.dropcontrol.tag") pk = "tag_id";
    else if (event.id_key === "admin.dropcontrol.users") pk = "usuario_id";
    else if (event.id_key === "admin.dropcontrol.fenologia") pk = "plantilla_estado_fenologico_id";
    else if (event.id_key === "admin.dropcontrol.reportes") pk = "reporte_id";
    else if (event.descripcion === "Inyector de Fertilizante Update") pk = "hidraulica_id";
    else if (event.descripcion?.includes("Tank Fertilizer")) pk = "estanque_id";

    const result = pk
        ?
        (
            event.data_json[pk]?.newValue?.nombre?.[i18n.language] ||
            event.data_json[pk]?.newValue?.nombre?.["en"] ||
            event.data_json[pk]?.newValue?.nombre ||
            event.data_json[pk]?.newValue?.[i18n.language] ||
            event.data_json[pk]?.newValue?.["en"] ||
            event.data_json[pk]?.nombre?.[i18n.language] ||
            event.data_json[pk]?.nombre?.["en"] ||
            event.data_json[pk]?.nombre ||
            event.data_json[pk]?.newValue ||
            event.data_json[pk]?.oldValue ||
            event.data_json[pk] ||
            ""
        )
        : "";
    delete event.data_json[pk];
    return result;
};

export default SystemEvents;

